import * as React from "react";
import { useSelector } from "react-redux";
import { Button, Menu, MenuItem, IconButton } from "@material-ui/core/";
import useStyles from "./styles";
import { useHistory, useLocation } from "react-router-dom";
import PersonIcon from "@material-ui/icons/Person";
import { Hidden } from "@material-ui/core";
const MyAccount = ({ logout }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { user } = useSelector((store) => store);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setDisplayName = () => {
    let name;
    if (user.user.displayName) name = user.user.displayName;
    else if (user.user.name) name = user.user.name;
    else if (user.user.email) name = user.user.email.toLowerCase();
    return name;
  };

  const goToAdmin = () => {
    setAnchorEl(null);
    history.push("/admin");
  };

  const goToProfile = () => {
    setAnchorEl(null);
    history.push("/profil");
  };

  const goToSettings = () => {
    setAnchorEl(null);
    history.push("/settings");
  };

  if (user.user.email) {
    return (
      <>
        <Hidden smDown>
          <Button
            id="basic-button"
            variant="outlined"
            aria-haspopup="true"
            onClick={handleClick}
            className={classes.button}
            size="large"
            style={{ color: "#fff" }}
          >
            {`${setDisplayName()}`}
          </Button>
        </Hidden>
        <Hidden smUp>
          <IconButton
            id="basic-button"
            variant="outlined"
            aria-haspopup="true"
            onClick={handleClick}
            className={classes.button}
            size="large"
            style={{ color: "#fff" }}
          >
            <PersonIcon />
          </IconButton>
        </Hidden>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className={classes.modernMenu}
          getContentAnchorEl={null} // ensure menu is anchored below the button
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          style={{ zIndex: 999 }}
        >
          {(user.user.email === process.env.REACT_APP_ADMIN || user.user.email === process.env.REACT_APP_ARI_ADMIN) && (
            <MenuItem onClick={() => goToAdmin()} className={classes.adminMenuItem}>
              Admin
            </MenuItem>
          )}
          <MenuItem onClick={() => goToProfile()} className={classes.menuItem}>
            Profil
          </MenuItem>
          <MenuItem onClick={() => goToSettings()} className={classes.menuItem}>
            Setări
          </MenuItem>
          {/* <MenuItem onClick={handleClose}>Change password</MenuItem> */}
          <MenuItem onClick={logout} className={classes.logoutMenuItem}>
            Delogare
          </MenuItem>
        </Menu>
      </>
    );
  }

  return (
    <Button
      id="basic-button"
      variant="outlined"
      aria-haspopup="true"
      onClick={() => history.push("/login")}
      className={classes.button}
      size="large"
      style={{ color: "#fff" }}
    >
      <PersonIcon />
    </Button>
  );
};

export default MyAccount;
